/* 商品ページ：色を選んだら、写真をその色に切り替える（sections/ksv-product と一緒に動く）
   1 色ごとの写真がある商品は、商品データの「バリエーションの画像」で切り替わる（ksv-product 側）
   2 色ごとの写真がなく、色見本の画像（ファイル名に _color）だけある商品（オリジナル熨斗など）は、
     色見本を選んだ色のところまで拡大して見せる。色見本は 3×3 で、並び順は選択肢の順と同じ */
(function () {
  var css = '.ksv-chart{position:relative;overflow:hidden}.ksv-chart img{transition:transform .7s cubic-bezier(.2,.6,.2,1)}'
    + '.ksv-chart__tag{position:absolute;left:12px;bottom:12px;z-index:2;padding:6px 12px;background:rgba(255,255,255,.92);font-size:12px;letter-spacing:.06em;color:#2B2B2B;opacity:0;transition:opacity .4s}'
    + '.ksv-chart.is-zoom .ksv-chart__tag{opacity:1}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function init(root) {
    var slides = root.querySelector('[data-ksv-slides]');
    if (!slides) return;
    var chart = null;
    slides.querySelectorAll('.ksv-p__slide').forEach(function (li) {
      var im = li.querySelector('img');
      if (im && /_color[._-]/i.test(im.getAttribute('src') || '')) chart = li;
    });
    var fs = null;
    root.querySelectorAll('.ksv-p__opt').forEach(function (f) { if (!fs && /カラー|色/.test(f.dataset.name || '')) fs = f; });
    if (!chart || !fs) return;
    var radios = Array.prototype.slice.call(fs.querySelectorAll('input[type=radio]')).filter(function (r) { return r.value.indexOf('下記より') !== 0; });
    if (radios.length < 2 || radios.length > 9) return;
    var img = chart.querySelector('img');
    chart.classList.add('ksv-chart');
    var tag = document.createElement('span');
    tag.className = 'ksv-chart__tag';
    chart.appendChild(tag);
    var thumbs = root.querySelectorAll('[data-ksv-thumb]');
    var cur = root.querySelector('[data-ksv-cur]');
    function show() {
      var i = -1;
      radios.forEach(function (r, k) { if (r.checked) i = k; });
      if (i < 0) return;
      var col = i % 3, row = Math.floor(i / 3);
      img.style.transformOrigin = (col * 50) + '% ' + (row * 50) + '%';
      img.style.transform = 'scale(2.4)';
      tag.textContent = '選んだ色：' + radios[i].value;
      chart.classList.add('is-zoom');
      var idx = Number(chart.dataset.index);
      slides.scrollTo({ left: slides.clientWidth * idx, behavior: 'smooth' });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === idx ? 'true' : 'false'); });
      if (cur) cur.textContent = idx + 1;
    }
    fs.addEventListener('change', function () { setTimeout(show, 60); });
  }
  function run() { document.querySelectorAll('.ksv-p').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
